<template>
  <div class="card m-4">
    <div class="grid grid-cols-6 gap-4">

      <div class="col-span-6">
        <label for="CodigoBarra">C&oacute;digo de Barra o N&ordm; Comprobante</label>
        <InputText id="CodigoBarra" type="text" v-model="data.save.codigoBarra" class="w-full" maxlength="40" />
      </div>

      <div class="col-span-6">

        <DataView :value="data.detalle">

          <template #list="slotProps">
            <div class="col-12">
              <div>
                <div class="product-list-detail">
                  <div class="product-name">{{slotProps.data.numero}}</div>
                  <div class="product-description">{{slotProps.data.detalle}}</div>
                  <i class="pi pi-tag product-category-icon"></i><span class="product-category">{{slotProps.data.fecha}}</span>
                </div>
                <div class="product-list-action">
                  <span class="product-price">${{slotProps.data.importe}}</span>
                  
                </div>
              </div>
            </div>
          </template>

        </DataView>

      </div>

      <div class="col-span-6">
        

      </div>

    </div>
  </div>
</template>
<script>
  import InputText from 'primevue/inputtext';
  import DataView from 'primevue/dataview';
import { reactive, vue } from 'vue';

  export default {
    components: {
      InputText, DataView
    },
    setup() {
      const data = reactive({
        detalle: [
          { fecha: '2022-09-14', numero: 'CU000100123456', periodo: '2022-09', importe: 100, detalle: 'observacion 1' },
          { fecha: '2022-10-22', numero: 'CU000100123467', periodo: '2022-10', importe: 100, detalle: 'observacion 2' },
          { fecha: '2022-11-01', numero: 'CU000100123443', periodo: '2022-11', importe: 100, detalle: 'observacion 3' },
        ],
        save: {
          codigoBarra: '',
        },
      });

      return {
        data,
      };
    }
  }
</script>